<div id="questions_list_content">   
    <div class="page_title_content">
        <div class="page_title">{{'QUESTIONS_LIST.TITLE' | translate}}</div>
        <div class="page_subtitle">{{'QUESTIONS_LIST.SUBTITLE' | translate}}</div>
    </div>
    
    @if(this.questionsNotAnswered.length > 0 || this.questionsAnswered.length > 0){
        <div id="questions_list">
            @for(questionNotAnswered of this.questionsNotAnswered; track $index){
                <app-questions-item [question]="questionNotAnswered" (onAnswerQuestion)="this.onAnswerQuestion($event)"/>
            }
            
            @if(this.questionsAnswered.length > 0){
                <div id="button_toogle_questions_answered" (click)="this.toggleQuestionsAnswered()">
                    <div id="button_toogle_questions_answered_label">{{'QUESTIONS_LIST.SEE_QUESTIONS_ANSWERED' | translate}} ({{this.questionsAnswered.length}})</div>
                    <ion-icon [name]="(this.displayQuestionsAnswered ? 'chevron-up-outline' : 'chevron-down-outline')"></ion-icon>
                </div>
                
                @if(this.displayQuestionsAnswered){
                    @for(questionAnswered of this.questionsAnswered; track $index){
                        <app-questions-item [question]="questionAnswered" />
                    }
                }
                
            }
            
        </div>
    }
    @else{
        <demooz-message type="info">{{'QUESTIONS_LIST.MSG_NO_QUESTION' | translate}}</demooz-message>
    }
    
    @if(this.showBtnShareQuestion){
        <div id="button_share_link_question_content">
            <demooz-button type="button" id="button_share_link_question" label="{{'QUESTIONS_LIST.BUTTON_SHARE_LINK' | translate}}" (click)="this.shareLinkQuestion()"/> 
        </div>
    }
    
</div>

<demooz-modal #modalAnswer size="small" (onDidDismiss)="this.onDidDismissModalAnswer($event)">
    @if(this.questionToAnswer){
        <app-questions-answer [question]="this.questionToAnswer" (onSendAnswerQuestion)="this.onSendAnswerQuestion($event)"/>
    }
</demooz-modal>